import { type FC, type PropsWithChildren, useEffect } from 'react';
import { Modal, Portal } from '@salutejs/sdds-insol';
import { classNames } from '@/shared/lib/classNames';
import cls from './ModalWrapper.module.scss';

type Props = {
    className?: string;
    hasBody?: boolean;
    id: string;
    isOpened: boolean;
    setIsOpened: (condition: boolean) => void;
};

export const ModalWrapper: FC<PropsWithChildren<Props>> = ({
    id,
    isOpened,
    className,
    hasBody = true,
    setIsOpened,
    children,
}) => {
    useEffect(() => {
        const root = document.getElementById('root');

        if (isOpened) {
            root?.classList.add('nonePointerEvents');
        } else {
            root?.classList.remove('nonePointerEvents');
        }
    }, [isOpened]);

    const onClose = () => {
        setIsOpened(false);
    };

    return (
        <Portal>
            <Modal className={cls.modal} id={id} opened={isOpened} hasClose={hasBody} hasBody={hasBody as true} onClose={onClose}>
                <div className={classNames(cls.container, {}, [className])}>{children}</div>
            </Modal>
        </Portal>
    );
};
